import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function InterventionPointsDetail({ detail, orderList = [] }) {
  const { t } = useTranslation();
  const rows = useMemo(() => {
    try {
      const items = Array.isArray(detail)
        ? detail
        : (Array.isArray(detail?.attributes) ? detail.attributes : []);

      const allAttrs = items.map(item => {
        const id = String(item?.objectTypeAttributeId || item?.id || '');
        const name = item?.objectTypeAttribute?.name || item?.name || id;
        const valuesArray = (item?.objectAttributeValues || item?.values || []);
        const values = valuesArray
          .map(v => {
            if (v?.referencedType && v?.referencedObject) {
              return v.referencedObject.label || v.displayValue || v.value;
            }
            return v?.displayValue || v?.value;
          })
          .filter(Boolean);
        return { id, name, values };
      });

      const byId = new Map(allAttrs.map(a => [String(a.id), a]));
      const byName = new Map(allAttrs.map(a => [String(a.name), a]));
      const result = [];

      for (const conf of (Array.isArray(orderList) ? orderList : [])) {
        const attr =
          (conf?.id && byId.get(String(conf.id))) ||
          (conf?.name && byName.get(conf.name)) ||
          null;
        if (!attr || !Array.isArray(attr.values) || attr.values.length === 0) {
          continue;
        }
        result.push({
          key: `${attr.id}-${attr.name}`,
          label: conf.label || attr.name,
          values: attr.values
        });
      }

      return result;
    } catch (_) {
      return [];
    }
  }, [detail, orderList]);

  if (!rows || rows.length === 0) {
    return <div className="text-xs text-gray-500">{t('No attribute available.')}</div>;
  }

  return (
    <div className="divide-y divide-gray-200">
      {rows.map(row => (
        <div key={row.key} className="py-1.5 flex items-start gap-3">
          <div className="w-20 shrink-0 text-[11px] text-gray-500">{row.label}</div>
          <div className="text-[12px] text-gray-900 break-words">{row.values.join(', ')}</div>
        </div>
      ))}
    </div>
  );
}


